import SEO from "../components/SEO";
import { Reveal, Eyebrow } from "../components/Reveal";
import { RateCards, useRates } from "../components/GoldRate";
import { Link } from "react-router-dom";

export default function RatesPage() {
  const { rates, loading, refresh } = useRates();
  return (
    <div data-testid="rates-page" className="pt-28 sm:pt-36">
      <SEO title="Live Gold Rate — Meerut"
        description="Today's 24K, 22K and 18K gold rates and silver rate — per gram and per 10 grams, from Ramesh Kapoor and Sons Jewellers Pvt. Ltd." />
      <header className="max-w-[1000px] mx-auto px-5 sm:px-8 pb-14">
        <Eyebrow>Live Bullion Desk</Eyebrow>
        <h1 className="font-serif font-light text-4xl sm:text-6xl tracking-tight text-[#FBF9F5] mt-4">
          Today’s Gold &amp; <span className="italic text-[#C5A059]">Silver Rate</span>
        </h1>
      </header>
      <section className="max-w-[1000px] mx-auto px-5 sm:px-8 pb-28">
        <Reveal>
          <RateCards rates={rates} loading={loading} refresh={refresh} />
        </Reveal>
        <Reveal delay={0.1} className="mt-14 border border-white/10 p-8 sm:p-10">
          <h2 className="font-serif text-2xl text-[#FBF9F5]">How Jewellery Pricing Works</h2>
          <p className="text-sm text-[#94A3B8] leading-loose mt-4">
            Final jewellery pricing depends on the current metal rate, net weight, purity, making charges, stone
            or diamond value, applicable taxes, and other disclosed charges. The rate shown here is the metal rate
            only — the price of a finished piece is confirmed at the counter with every component disclosed.
          </p>
          <Link to="/jewellery/appointment" data-testid="rates-appointment-btn"
            className="inline-block mt-8 text-[11px] uppercase tracking-[0.2em] font-semibold bg-[#C5A059] text-[#060A12] px-8 py-4 hover:bg-[#d6b678] transition-colors duration-300">
            Book an Appointment
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
